<template>
  <div class="w_100per h_100per">
    <HomeSlot ref="homeslot" :footercolor="'gray'">
      <template #home-main>
        <div class="aichannelpreview-container">
          <div class="video-wrap">
            <a class="sound-onoff-iconwrap" @click="onClickMute">
              <img
                class="sound-onoff-icon cursor"
                :src="isMute ? '/media/images/icon/sound-off-icon.png' : '/media/images/icon/sound-on-icon.png'"
                alt="sound-off-icon.png"
              />
            </a>
            <video
              autoplay
              muted
              loop
              ref="aichannelVideo"
              class="aichannel-video"
              src="/media/images/video/aichannelpreview.mp4"
            >
              <a class="sound-onoff-iconwrap" @click="onClickMute">
                <img
                  class="sound-onoff-icon cursor"
                  :src="isMute ? '/media/images/icon/sound-off-icon.png' : '/media/images/icon/sound-on-icon.png'"
                  alt="sound-off-icon.png"
                />
              </a>
            </video>
          </div>
          <a tabindex="0" class="goservice-btnwrap" @click="onClickService">
            <button class="goservice-btn">
              서비스 바로가기
            </button>
          </a>
        </div>
      </template>
    </HomeSlot>
  </div>
</template>
<script>
import HomeSlot from '@/slot/HomeSlot.vue';
export default {
  emits: ['click-login'],
  data() {
    return {
      isMute: true
    };
  },

  components: {
    HomeSlot
  },
  mounted() {
    document.querySelector('video').playbackRate = 1.7;
    this.$nextTick(() => {
      window.scrollTo(0, 0); // 또는 document.documentElement.scrollTop = 0;
    });
  },
  methods: {
    onClickService() {
      this.$refs.homeslot.isOpenSocialSignUp = true;
    },
    onClickMute() {
      this.isMute = !this.isMute;
      if (this.isMute) {
        this.$refs.aichannelVideo.muted = true;
      } else {
        this.$refs.aichannelVideo.muted = false;
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/aichannelpreview/aichannelpreview.css"></style>
